import { Button, HStack, Icon, Input, InputGroup, InputRightElement, useStyleConfig } from '@chakra-ui/react';
import {fetchMoreBullets} from './utils';
import { RiSearchLine } from 'react-icons/ri';

const SearchBox=({ jobSeekerData, props })=>{

  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  return (
    <HStack spacing="24px">
      <InputGroup>
        <Input
          id="bulletSearch"
          onKeyDown={e=> {
            if (e.key === 'Enter') {
              fetchMoreBullets(jobSeekerData, props, 0);
            }
          }}
          placeholder='search for more bullets'
          sx={{ paddingRight: 0, margin: 0 }}
        />
        <InputRightElement>
          <Button
            sx={{...buttonStyles.search}}
            onClick={e => {
              fetchMoreBullets(jobSeekerData, props, 0);
            }}
          >
            <Icon as={RiSearchLine} w={4} m={0} p={0} />
          </Button>
        </InputRightElement>
      </InputGroup>
    </HStack>
  )
}
export default SearchBox;